module.exports = __webpack_public_path__ + "static/img/QA@2x.8b716080.jpg";